module.exports = __webpack_public_path__ + "static/media/m3pblack.452cf764.png";